import * as React from "react";
const SvgListSelect = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 18a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1M8 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1M5.337 4.808a.186.186 0 1 1 .263.263L3.62 7.052a.186.186 0 0 1-.264 0l-.9-.9a.186.186 0 1 1 .263-.264l.768.77z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.173 4.492a.54.54 0 0 1 .59 0l.085.068.068.085a.54.54 0 0 1-.068.674L3.866 7.3c-.209.21-.549.21-.758 0l-.9-.9a.537.537 0 0 1 0-.759l.084-.068a.54.54 0 0 1 .59 0l.084.068.52.52L5.09 4.56zM8 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1M5.337 10.808a.186.186 0 1 1 .263.263l-1.98 1.981a.186.186 0 0 1-.264 0l-.9-.9a.186.186 0 1 1 .263-.264l.768.77z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.173 10.492a.54.54 0 0 1 .59 0l.085.068.068.085a.536.536 0 0 1-.068.674L3.866 13.3c-.209.21-.549.21-.758 0l-.9-.9a.537.537 0 0 1 0-.759l.084-.068a.54.54 0 0 1 .59 0l.084.068.52.52L5.09 10.56zM5.337 16.808a.186.186 0 1 1 .263.263l-1.98 1.981a.186.186 0 0 1-.264 0l-.9-.9a.186.186 0 1 1 .263-.264l.768.77z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.173 16.492a.54.54 0 0 1 .59 0l.085.068.068.085a.536.536 0 0 1-.068.674L3.866 19.3c-.209.21-.549.21-.758 0l-.9-.9a.537.537 0 0 1 0-.759l.084-.068a.54.54 0 0 1 .59 0l.084.068.52.52L5.09 16.56z"
}));
export default SvgListSelect;
//# sourceMappingURL=ListSelect.js.map